var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: {
        "enter-active-class": "ease-out duration-200",
        "enter-class": "opacity-0 transform -translate-x-10",
        "enter-to-class": "opacity-100 translate-x-0",
        "leave-active-class": "ease-in duration-200",
        "leave-class": "opacity-100",
        "leave-to-class": "opacity-0",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.display,
              expression: "display",
            },
          ],
          staticClass: "text-gray-600 text-base leading-8 prose max-w-none",
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }